<template>
	<div class="mbti-feedback stage" :style="{ 'background-image': backgroundImage }">

		<div class="header__container">
			<div class="header" style="position: relative">
				{{feedback.header}}
			</div>
			<div class="subHeader" style="position: relative">
				{{feedback.subheader}}
			</div>
		</div>

		<div class="panel small" style="position: relative">
			<div class="text" :style="'color: '+trueColors[trueColorsClassificationResult][1]">
				<span class="truecolors-label">{{trueColors[trueColorsClassificationResult][2]}}</span> <span class="color-indicator" :style="'background-color: '+trueColors[trueColorsClassificationResult][1]"></span>
			</div>
		</div>


		<div class="panel" style="position: relative">
			<div class="text" style="position: relative" v-html="feedback.feedbacktext">
			</div>
		</div>

	</div>
</template>

<script>

	import Lottie from '../../../Lottie.vue';
	import { url} from '../../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		components:{
			Lottie,
		},

		beforeMount(){
			this.findCorrectFeedback();
		},

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(this.lastRound ? this.toNextStage : this.toNextRound).then(()=>{
					this.showNextButton().then(()=> {
						this.setMbtiProfile(this.mbtiProfile);
					});
				});
			},500);
		},

		data(){
			return {
				baseUrl : url,
				classificationsArray : {"E":0, "I":0, "S":0, "N":0, "T":0, "F":0, "J":0, "P":0},
				classificationPairsArray : ["E,I", "S,N", "T,F", "J,P"],
				classificationResult: [],
				classificationResultString: false,
				trueColors: {
					'guardian': ['Goud', '#DB9F49', 'Verzorger'],
					'artisan': ['Oranje', '#FFAE61', 'Vakman'],
					'idealist': ['Blauw', '#17ABB4', 'Idealist'],
					'rationalist': ['Groen', '#17B46F', 'Rationalist']
				},
				trueColorsClassification: {
					'guardian': ['ESTJ', 'ISTJ', 'ESFJ', 'ISFJ'],
					'artisan': ['ESTP', 'ISTP', 'ESFP',  'ISFP'],
					'idealist': ['ENFJ', 'INFJ', 'ENFP', 'INFP'],
					'rationalist': ['ENTJ', 'INTJ', 'ENTP', 'INTP']
				},
				trueColorsClassificationResult: false,
				mbtiProfile: {
					"mbtiClassification":false,
					"trueColorClassification":false
				},
			}
		},
		methods:{
			...mapActions([
				"setNextButtonAction",
				"showNextButton",
				"toNextStage",
				"toNextRound",
				"setMbtiProfile"
			]),

			findCorrectFeedback(){

				for(let i = 0 ; i < this.feedbackData.answers.length ; i++){
					const answer = this.feedbackData.answers[i];
					this.classificationsArray[answer]++;
				}

				//check which of each pairs is the favourite
				for(let i = 0 ; i < this.classificationPairsArray.length ; i++){
					const pair = this.classificationPairsArray[i].split(",");
					let highest = 0;
					let dominatingClass = false;
					for(let j = 0 ; j < pair.length ; j++){
						if(this.classificationsArray[pair[j]] > highest){

							highest = this.classificationsArray[pair[j]];

							dominatingClass = pair[j];

						}else{
							dominatingClass = pair[0];
						}
					}



					this.classificationResult.push(dominatingClass);

					
				}

				this.classificationResultString = this.classificationResult.join("");

				//find the trueColors indicator
				
				for (var k in this.trueColorsClassification){
				    if (this.trueColorsClassification.hasOwnProperty(k)) {
				        
				        if(this.trueColorsClassification[k].indexOf(this.classificationResultString) !== -1){

				        	this.trueColorsClassificationResult = k;
				        }

				    }
				}

				this.mbtiProfile.mbtiClassification = this.classificationResultString;
				this.mbtiProfile.trueColorClassification = this.trueColors[this.trueColorsClassificationResult];
				
				console.log(this.mbtiProfile.trueColorClassification[2]);

			},

		},
		computed:{
			...mapGetters([
				"questionData",
				"feedbackData",
				"lastRound",
				'roundData',
			]),

			feedback(){

				for(let i = 0 ; i < this.roundData.questions.feedback.length ; i++){

					if(this.roundData.questions.feedback[i].mbtiprofile == this.mbtiProfile.trueColorClassification[2]){

						return this.roundData.questions.feedback[i];
					}

				}

				return this.roundData.questions.feedback[0];
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/feedback/mbtiprofile/Index.vue